export const environment = {
    apiUrl: 'https://api.ur-valet.io/api/v1/',
    apiUrlHttp: 'http://api.ur-valet.io/api/v1/',

};
